import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { IconModule } from '@rd/shared-legacy/components/icon/icon.module';
import { ImpersonationService } from '../../services/impersonation/impersonation.service';

@Component({
  imports: [CommonModule, IconModule],
  selector: 'rd-core-impersonation-banner',
  template: `
    <div
      class="fixed bottom-0 left-0 right-0 z-[500] h-1 bg-[#ED5E6F]"
      *ngIf="impersonationService.isImpersonated">
      <div
        class="absolute bottom-full left-6 flex max-w-[237px] gap-3 rounded-t-[4px] bg-[#ED5E6F] p-4 text-white">
        <div class="h-4 w-4 flex-shrink-0">
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g id="info-button">
              <path
                id="Shape"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.5144 3.20017C11.3902 0.0763125 6.32472 0.0759647 3.20017 3.20017C0.0759571 6.32438 0.0763049 11.3898 3.20017 14.5144C6.32437 17.6379 11.3898 17.6382 14.5144 14.5144C17.6382 11.3898 17.6379 6.32473 14.5144 3.20017ZM9.90041 12.3356C9.90041 12.9119 9.43328 13.3791 8.85692 13.3791C8.28057 13.3791 7.81343 12.9119 7.81343 12.3356V8.16162C7.81343 7.58526 8.28057 7.11813 8.85692 7.11813C9.43328 7.11813 9.90041 7.58526 9.90041 8.16162V12.3356ZM7.84926 5.42663C7.83674 5.9522 8.23744 6.37795 8.83849 6.37795C9.46458 6.37795 9.86493 5.9522 9.86528 5.42663C9.85241 4.87602 9.46423 4.4628 8.85066 4.4628C8.23744 4.4628 7.83674 4.87567 7.84926 5.42663Z"
                fill="white" />
            </g>
          </svg>
        </div>
        <p class="m-0">
          You are signed in as user
          <span class="font-bold">{{
            impersonationService.impersonatedUsername
          }}</span>
        </p>
      </div>
    </div>
  `,
})
export class ImpersonationBannerComponent {
  readonly impersonationService = inject(ImpersonationService);
}
